import { useCallback, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import ReCAPTCHA from 'react-google-recaptcha';
import axios from 'axios';
import useAuth from '../auth/useAuth';
import AuthLayout from './components/AuthLayout';
import AuthTitle from './components/AuthTitle';
import './ForgotPasswordPage.css';

const validationSchema = Yup.object({
  email: Yup.string().email('Invalid email address').required('Email is required'),
  recaptcha: Yup.string().required('ReCaptcha is required'),
});

const ForgotPasswordPage = () => {
  const [success, setSuccess] = useState(false);
  const [erCaptcha, setErCaptcha] = useState(false);
  const reCaptchaRef = useRef();
  const auth = useAuth();
  const history = useHistory();
  const source = axios.CancelToken.source();

  const handleSubmit = async (email) => {
    try {
      await axios.post(`/api/v3/user/forgot-password?email=${email}`);
      setSuccess(true);
    } catch (error) {
      formik.setErrors({ submit: 'Something went wrong' });
    }
  };

  const formik = useFormik({
    initialValues: {
      email: '',
      recaptcha: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      handleSubmit(values.email);
    },
  });

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, [source]);

  const handleCaptchaChange = useCallback((value) => {
    formik.setFieldValue('recaptcha', value);
    setErCaptcha(!value);
  }, []);

  return (
    <AuthLayout>
      <div className="forgot-password-page__container">
        {success ? (
          <div className="forgot-password-page__success">
            <h2>Check your email inbox</h2>
            <p>
              <a href="/login" onClick={(e) => { e.preventDefault(); history.push('/login'); }}>
                Sign In
              </a>
            </p>
            <small>
              Please allow up to 5 minutes for the email to come through before attempting to reset your password again.
            </small>
          </div>
        ) : (
          <>
            <AuthTitle>Forgot Password</AuthTitle>
            <form onSubmit={formik.handleSubmit} className="forgot-password-page__form">
              <input
                type="email"
                placeholder="Email"
                name="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                className={`forgot-password-page__input ${formik.touched.email && formik.errors.email ? 'forgot-password-page__input--error' : ''}`}
              />
              {formik.touched.email && formik.errors.email && (
                <span className="forgot-password-page__error">{formik.errors.email}</span>
              )}
              {formik.errors.submit && (
                <div className="forgot-password-page__alert">{formik.errors.submit}</div>
              )}
              <div className="forgot-password-page__action-row">
                <div className="forgot-password-page__captcha">
                  <ReCAPTCHA
                    ref={reCaptchaRef}
                    sitekey="6Lc6O9AUAAAAAF6myYURrvZwW43E4ShPeKOVKCHe"
                    onChange={handleCaptchaChange}
                  />
                  {(formik.touched.recaptcha && formik.errors.recaptcha) || erCaptcha ? (
                    <span className="forgot-password-page__error">
                      {formik.errors.recaptcha || 'ReCaptcha error'}
                    </span>
                  ) : null}
                </div>
                <button type="submit" className="forgot-password-page__button">
                  Reset Password
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </AuthLayout>
  );
};

export default ForgotPasswordPage;
